import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.DownloadOrLinksExtended),
  () => import('./DownloadOrLinksExtended'),
  (DownloadOrLinksExtended) => {
    ComponentUtil.binder(Hooks.DownloadOrLinksExtended, DownloadOrLinksExtended);
  },
);
